const whenJQuery = require('common-core/when-jquery');
const WithdrawExperimentException = require('common-core/withdraw-experiment-exception');

class JQueryRequirement {
  static check() {
    return whenJQuery()
      .then($ => {
        const moduleId = require.resolve('./jquery-global');
        // Manually insert it into the cache.
        require.cache[moduleId] = {
          exports: $,
          id: moduleId,
          loaded: true
        };
        return $;
      })
      .catch(e => {
        if (e instanceof Error && typeof e.message === 'string' &&  e.message.indexOf('Could not find jQuery in') === 0) {
          throw new WithdrawExperimentException(e.message);
        } else {
          throw e;
        }
      });
  }
}

module.exports = JQueryRequirement;



// WEBPACK FOOTER //
// ./src/common/core-requirements/jquery-requirement.js